import {
  Layout,
  Typography
} from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useServiceNeedContext } from "../../../context/ServiceNeedContext";
import LabeledOption from "../../LabeledOption";

const labeledOptionConfigs = [
  {
    name: "accountingServiceNeed",
    labelKey: "OnlineStatus.PossiblyYesShareContact",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setAccountingServiceNeed,
    value: true
  },
  {
    name: "accountingServiceNeed",
    labelKey: "OnlineStatus.NotThisTimeThanks",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setAccountingServiceNeed,
    value: false
  },
];

const AccountingServiceNeedPage = () => {
  const context = useServiceNeedContext();
  const { t } = useTranslation();

  return (
    <Layout.Flex flexDirection="column" flexGap={0}>
      <StyledTypography
        as="h3"
        color="secondary"
        variant="headingH4Regular"
        styleOverrides={{ paddingTop: 20, paddingBottom: 10 }}
      >
        {t("OnlineStatus.NeedAccountingServices")}
      </StyledTypography>
      {labeledOptionConfigs.map(({ name, labelKey, setter, value }, index) => (
        <LabeledOption
          key={`${name}-${index}`}
          name={name}
          labelKey={labelKey}
          onChange={() => setter(context)(value)}
          type="radio"
          checked={context.accountingServiceNeed === value}
        />
      ))}
    </Layout.Flex>
  )
}

export default AccountingServiceNeedPage;

const StyledTypography = styled(Typography)`
  @media (max-width: 768px) {
    font-size: 20px;
    padding-bottom: 80px;
  }
`;